import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import Cart from "../Cart/Cart";
import CheckoutForm from './CheckoutForm.js';
import Footer from "../Footer/Footer.js";
import { Helmet } from "react-helmet-async";

const Checkout = (props) => {

  const context = props.context
  const cart = context.cart

  const [total, setTotal] = useState(0);
  const [showCheckout, setShowCheckout] = useState(false);

  const handleShowCheckout = function () {
    if (total > 0){
      setShowCheckout(!showCheckout) //Toggle show cart
    }
  }

  useEffect(() => {
    // console.log('Update cart', cart)
    let subtotal = 0;
    if (cart.length > 0){
      for(let i=0; i < cart.length; i++){
        subtotal += cart[i].price
      }
    }
    setTotal(subtotal)
  }, [cart])

  return (
    <div className="container-top" id="checkout">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content="It's A Good Life Fitness" />
        <title>It's A Good Life Fitness | Checkout</title>
        <link rel="canonical" href="https://itsagoodlifefitness.com" />
      </Helmet>
      <h1>Check<span>o</span>ut</h1>
      <div className="checkout">
        <div className="checkout-container" id="formtop">
          {/*  */}
          {showCheckout ? (
            <CheckoutForm total={total} {...props} />
          ):(
            <Cart {...props} />
          )}
          {/*  */}
          <div className="summary-container">
            <div className="order-summary">
              <div className="order-heading">
                <h2>Order Summary</h2>
              </div>
              {showCheckout && (<>
              
                {cart.length > 0 ? (
                  <>
                  {cart.map((item, index) => {
                    return(
                      <div className="item" key={index}>
                        <div className="name">{item.name}</div>
                        <div className="price">${item.price}.00</div>
                      </div>
                    )
                  })}
                  </>
                  ):(
                    <>
                    </>
                  )}
                </>)}
              <div className="item">
                <div className="name">Subtotal</div>
                <div className="price">${total}.00</div>
              </div>
              <div className="item">
                <div className="name">TOTAL (USD)</div>
                <div className="price">${total}.00</div>
              </div>
            </div>
            <div className="button-container">
              <Link to="#formtop">
                <button className="button" onClick={handleShowCheckout}>
                  {showCheckout ? (<span>Edit Cart</span>):(<span>Check Out</span>)}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer {...props} />
    </div>
  );
};

export default Checkout;
